"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SassAlias = void 0;
var path_1 = __importDefault(require("path"));
var alias_1 = require("./alias");
var SassAlias = (function () {
    function SassAlias(alias) {
        this.alias = new alias_1.Alias(alias);
    }
    SassAlias.prototype.getAlias = function () {
        return this.alias;
    };
    SassAlias.prototype.getImporter = function () {
        var _this = this;
        return function (url) {
            var resolvedUrl = _this.alias.resolve(url);
            return resolvedUrl ? { file: path_1.default.resolve(resolvedUrl) } : null;
        };
    };
    return SassAlias;
}());
exports.SassAlias = SassAlias;
//# sourceMappingURL=sass-alias.js.map